import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { paymentStatus, trackEvent } from "../lib/api";

export default function Payment() {
  const location = useLocation();
  const cancelled = location.pathname.includes("cancel");
  const [state, setState] = useState(cancelled ? "cancelled" : "checking");
  const [order, setOrder] = useState(null);
  const tries = useRef(0);

  useEffect(() => {
    if (cancelled) return;
    const sid = new URLSearchParams(location.search).get("session_id");
    if (!sid) { setState("error"); return; }
    localStorage.removeItem("pgt_review");
    const poll = async () => {
      try {
        const r = await paymentStatus(sid);
        if (r.payment_status === "paid" && r.order_number) { setOrder(r); setState("paid"); trackEvent("purchase_completed", null, { order_number: r.order_number }); return; }
      } catch (e) {}
      tries.current += 1;
      if (tries.current > 20) { setState("pending"); return; }
      setTimeout(poll, 2000);
    };
    poll();
  }, [cancelled, location.search]);

  return (
    <div className="min-h-screen bg-pgt-bg">
      <div className="max-w-xl mx-auto px-6 py-24 text-center">
        {state === "checking" && <div className="text-pgt-green font-display text-2xl tracking-widest pgt-pulse" data-testid="payment-checking">CONFIRMING PAYMENT…</div>}
        {state === "paid" && (
          <div data-testid="payment-success">
            <div className="w-14 h-1 bg-pgt-green mx-auto mb-6" />
            <h1 className="pgt-heading text-white text-5xl mb-3">Order Confirmed</h1>
            <p className="text-white/60 mb-2">Your order number is</p>
            <div className="font-display font-extrabold text-pgt-green text-4xl mb-6" data-testid="order-number">{order.order_number}</div>
            <p className="text-white/60 mb-8">Our team will review your artwork before your turf enters production. A confirmation email is on its way.</p>
            <Link to={`/order/${order.order_number}?token=${order.access_token}`} data-testid="view-order-btn"
              className="inline-block bg-pgt-green text-black font-display font-bold uppercase tracking-wider px-8 py-4 rounded-sm hover:bg-pgt-greenHover transition-colors">View Your Order →</Link>
          </div>
        )}
        {(state === "cancelled" || state === "pending" || state === "error") && (
          <div data-testid="payment-cancel">
            <h1 className="pgt-heading text-white text-5xl mb-3">{state === "cancelled" ? "Payment Cancelled" : state === "pending" ? "Payment Processing" : "Something Went Wrong"}</h1>
            <p className="text-white/60 mb-8">{state === "pending" ? "Your payment is still processing. Check your email shortly for confirmation." : "No charge was made. Your design is saved — you can pick up where you left off."}</p>
            <Link to="/design" className="inline-block bg-pgt-green text-black font-display font-bold uppercase tracking-wider px-8 py-4 rounded-sm hover:bg-pgt-greenHover transition-colors">Back To Designer</Link>
          </div>
        )}
      </div>
    </div>
  );
}
